export type SuppressionFormData = {
  firstName: string;
  surname: string;
  email: string;
  telephone: string;
  addressLine1: string;
  postcode: string;
  vehicleRegistration: string;
  vin: string;
  suppressionReason: string;
  marketingChannels: string[];
};

export type CreateFromSuppressionRequest = {
  campaignId: number;
  surname: string;
  postCode: string;
  vehicleRegistration: string;
  vehicleVIN: string;
  country: string;
  goneAwaysReason: number;
  unsubscribeOptions: number[];
  firstName: string;
  emailAddress: string;
  phoneNumber: string;
  addressLine1: string;
};

export type SuppressionFormErrors = {
  surname?: string;
  email?: string;
  telephone?: string;
  addressLine1?: string;
  postcode?: string;
  vehicleRegistration?: string;
  vin?: string;
  suppressionReason?: string;
  marketingChannels?: string;
};

export const SuppressionReason = {
  None: '0',
  NotInterested: '14',
  AlreadyRenewed: '12',
  PurchasedElsewhere: '13',
  NoLongerOwnVehicle: '6'
} as const;

export const MarketingChannel = {
  AllMarketing: '1',
  DirectMail: '2',
  Email: '3',
  SMS: '4',
  Telephone: '5'
} as const;
